module.exports = __webpack_public_path__ + "img/2-3.126f089c.svg";